import React from 'react';

import { flagStyles } from '../settings';

const SvgGM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1992px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGM;
